import type TableView from "../store/schema/TableView";

/**
 * Returns whether the user has selected exactly one message and no collapsed
 * group header, which is the only case where the selection is shown in the
 * reading pane.
 *
 * This is the counterpart of `isMultipleSelection`; neither returns true for an
 * empty selection.
 *
 * @param tableView the table view
 */
export default function isSingleItemSelection(tableView: TableView): boolean {
    return tableView.selectedGroupHeaders.size === 0 && tableView.selectedRowKeys.size === 1;
}
